import { QuotesStatusKeys } from 'domain/quotes-status-enum';
import numeral from 'numeral';

export class Contractor {
  static getExtraCost(materials = [], time = [], vendorInvoices = []) {
    // Add materials costs
    let extraCost = materials.reduce((total, material) => {
      return total + numeral(material.cost).value();
    }, 0);

    // Add time costs
    extraCost = time.reduce((total, time) => {
      return total + (time.cost !== null ? numeral(time.cost).value() : 0);
    }, extraCost);

    // Add vendor invoices costs
    extraCost = vendorInvoices.reduce((total, invoice) => {
      return total + numeral(invoice.cost).value();
    }, extraCost);
    return extraCost;
  }

  static getNetCost(
    quotes = [],
    changeOrderTasks = [],
    materials = [],
    time = [],
    vendorInvoices = []
  ) {
    const totalCost = Contractor.getTotalCost(quotes, changeOrderTasks, true);
    const extraCost = Contractor.getExtraCost(materials, time, vendorInvoices);
    return totalCost - extraCost;
  }

  /**
   * Get total costs of Contractor, given if the quotes should be approved or not.
   * @param quotes
   * @param approved
   * @return {*}
   */
  static getTotalCost(quotes = [], changeOrderTasks = [], approved = false) {
    let totalCost = quotes
      .filter((quote) => {
        let status =
          quote.status !== QuotesStatusKeys.WITHDRAWN &&
          quote.status !== QuotesStatusKeys.WAITING;
        if (status && approved) {
          status = status && quote.status === QuotesStatusKeys.APPROVED;
        }
        return status;
      })
      .reduce((total, quote) => total + Math.round(quote.estimate), 0);

    totalCost += changeOrderTasks
      .filter(
        (cot) =>
          cot.status === QuotesStatusKeys.APPROVED ||
          cot.status === QuotesStatusKeys.ACR
      )
      .reduce(
        (total, cot) => total + Math.round(cot.change_order_quote.estimate),
        0
      );

    return totalCost;
  }

  static getVariancePercentage(
    quotes = [],
    changeOrderTasks = [],
    materials = [],
    time = [],
    vendorInvoices = []
  ) {
    const totalCost = Contractor.getTotalCost(quotes, changeOrderTasks, true);
    const extraCost = Contractor.getExtraCost(materials, time, vendorInvoices);
    return (totalCost - extraCost) / totalCost;
  }
}



// WEBPACK FOOTER //
// ./src/domain/contractor.js